import React, { FC, PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { IntlProvider, MessageFormatElement } from 'react-intl';

import themes from '@bitcoin-portal/bitcoincom-pkg-theme';

import { GlobalStyle } from './styled';

import { DEFAULT_LOCALE } from '../../i18n';

const providerTheme = themes.light;

interface Props {
  messages:
    | Record<string, string>
    | Record<string, MessageFormatElement[]>
    | undefined;
  locale: string;
}

const Layout: FC<PropsWithChildren<Props>> = props => {
  const { messages, children, locale } = props;

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      defaultLocale={DEFAULT_LOCALE}
    >
      <ThemeProvider theme={providerTheme}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </IntlProvider>
  );
};

export default Layout;
